/*
 * SPDX-FileCopyrightText: 2022 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import type { AuthProvider } from '../../../api/config/types'
import { authProviderTypeOneClick } from '../../../api/config/types'
import { getMe } from '../../../api/me'
import { setUser } from '../../../redux/user/methods'

/**
 * Fetches metadata about the currently signed-in user from the API and stores it into the redux.
 */
export const fetchAndSetUser: () => Promise<void> = async () => {
  const user = await getMe();
  const me = user.data[0].attributes;
  const imageToolsAccessUser = ['content_creator', 'admin'];
  setUser({
    username: me.name,
    displayName: me.name,
    photo: me.image,
    authProvider: me.authProvider,
    email: me.email,
    roles: me.roles,
    hasImageToolsAccess: me.roles.some((role: {
      name: string;
      id: number;
    }) => imageToolsAccessUser.includes(role.name)),
  })
}

/**
 * Filter to apply to a list of auth providers to get only one-click providers.
 *
 * @param provider The provider to test whether it is a one-click provider or not.
 * @return {@link true} when the provider is a one-click one, {@link false} otherwise.
 */
export const filterOneClickProviders = (provider: AuthProvider): boolean => {
  return authProviderTypeOneClick.includes(provider.type)
}
